import { render } from "./VposRegister.vue?vue&type=template&id=019010b2"
import script from "./VposRegister.vue?vue&type=script&lang=js"
export * from "./VposRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__